/**
 * @Author: Caroline
 * @Desc: hvyogo-front-cms
 * @Date: 2021-3-17
 */
import Vue from 'vue';
import Vuex from 'vuex';
import state from "./states";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
});


// WEBPACK FOOTER //
// ./src/store/store.js